import React, { useState } from "react";
import { Form } from "react-bootstrap";
import styles from "./FileUpload.module.css";
// import imageCompression from "browser-image-compression";
import LoadingIcon from "../../CssIcon/Loading/LoadingIcon";
import { useTranslation } from "react-i18next";
import ConfirmNotSfwModal from "../../Modal/ConfirmNotSfwModal.tsx/ConfirmNotSfwModal";
import globalStyles from "../../../styles/globalStyles.module.css";
import { NSFWJS } from "nsfwjs";
// Removed static import: import { NSFWJS } from "nsfwjs";

interface FileUploadProps {
  onFileChange: (file: File) => void; // Change: Pass File object instead of a string
  handleIsNsfw?: (isNsfw: boolean) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({
  onFileChange,
  handleIsNsfw = null,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isNsfw, setIsNsfw] = useState<boolean>(false);
  const { t } = useTranslation();
  const probabilityThreshold = 0.4;
  const [error, setError] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  let model: NSFWJS | null = null;

  const loadNSFWModel = async () => {
    if (model) {
      console.log("Model already loaded.");
      return model;
    }

    try {
      console.log("Loading NSFW model...");
      const nsfwjs = await import("nsfwjs");
      model = await nsfwjs.load(
        "https://cdn.cardonize.com/public/file/nsfwjs/models/model.json"
      );
      return model;
    } catch (error) {
      console.error("Failed to load NSFW model:", error);
      return null;
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    const file = e.target.files?.[0];
    if (file) {
      const imageElement = document.createElement("img");
      imageElement.src = URL.createObjectURL(file);

      if (handleIsNsfw) {
        const model = await loadNSFWModel();
        if (model) {
          imageElement.onload = async () => {
            try {
              const predictions = await model.classify(imageElement);
              console.log("predictions", predictions);
              const isUnsafe = predictions.some(
                (prediction) =>
                  ((prediction.className === "Hentai" ||
                    prediction.className === "Porn") &&
                    prediction.probability > probabilityThreshold) ||
                  (prediction.className === "Sexy" &&
                    prediction.probability > 2 * probabilityThreshold)
              );
              setIsNsfw(isUnsafe);
              handleIsNsfw(isUnsafe);
            } catch (error) {
              console.error("NSFW classification failed:", error);
            }
          };
        }
      }
      // Wait for the image to load

      if (file.size > 5 * 1024 * 1024) {
        setError("File size exceeds 5MB. Please upload a smaller file.");
        // console.log("compressing");
        // const options = {
        //   maxSizeMB: 0.5,
        //   useWebWorker: true,
        // };

        // try {
        //   console.log("try");
        //   const compressedFile = await imageCompression(file, options);

        //   onFileChange(compressedFile);
        // } catch (error) {
        //   console.error("Compression failed:", error);
        // }
      } else {
        setError(null);
        onFileChange(file);
      }
    }
    setLoading(false);
  };

  const handleOverrideNsfw = () => {
    setIsNsfw(false);
    if (handleIsNsfw) {
      handleIsNsfw(false);
    }
  };

  return (
    <>
      <ConfirmNotSfwModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        setIsNsfw={handleOverrideNsfw}
      />

      <div>
        {loading && <LoadingIcon />}
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>{t("input.upload.label")}</Form.Label>
          <Form.Control
            type="file"
            onChange={handleFileChange}
            accept="image/*"
            className={styles.formControl}
          />
        </Form.Group>
        <strong className={styles.alert}>
          {error && <div>{error}</div>}
          {isNsfw && handleIsNsfw && (
            <div className="d-flex align-items-center gap-2">
              <div>{t("nsfwDetected")}</div>
              <button
                onClick={() => setShowModal(true)}
                className={globalStyles.button}
              >
                {t("deny")}
              </button>
            </div>
          )}
        </strong>
      </div>
    </>
  );
};

export default FileUpload;
